export class Constants {
    public static readonly TABLE_DATA_CTRL_NAME = 'tableDataCtrlName';
}